// LOT 55 · format unique des montants d'en-tête, ronds et tuiles (ordinateur et mobile)
// ≥ 10 000 : « 181,5 k » (toujours une décimale) · en dessous : montant entier « 8 450 » · les listes et cartes gardent le montant complet
const NB = /^-?\d+([.,]\d+)?$/;
export const kEntete = (v) => {
  if (typeof v !== 'string' && typeof v !== 'number') return v;
  const s = String(v).trim();
  const brut = s.replace(/[\s\u202f\u00a0]/g, '');
  if (!NB.test(brut)) return v;
  const n = parseFloat(brut.replace(',', '.'));
  if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(1).replace('.', ',')} M`;
  if (Math.abs(n) >= 1e4) return `${(n / 1e3).toFixed(1).replace('.', ',')} k`;
  if (!/[.,]/.test(brut) || Math.abs(n) >= 100) return Math.round(n).toLocaleString('fr-FR');
  return s;
};
// carte du chiffre : montant complet sans décimales
export const complet = (n) => (n == null || n === '' ? '—' : Math.round(Number(n)).toLocaleString('fr-FR'));
